import React from 'react';
import swal from 'sweetalert';
import ReactTable from 'react-table';
import moment from 'moment';
import 'react-table/react-table.css';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Print, NoPrint } from 'react-easy-print';
import { spmfcloudFunctionUrl } from '../../actions/salesforces';
import { fetchQueryData } from '../../utils/sf-request';

class BeneficiaryList extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            list: [],
            latestPayoutDate: '',
            contactInfo: {},
        };

        this.getPayoutDate = this.getPayoutDate.bind(this);
        this.search = this.search.bind(this);
    }

    async componentWillMount() {
        try {
            if (!this.props.isModal) await this.search(this.props.match.params.query);
        } catch (error) {
            swal({
                text: error.toString(),
                title: 'An error when getting beneficiary records',
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps === this.props) return;
        if (this.props.isModal) {
            this.search(nextProps.match.params.query);
        }
    }

    async getContact(idNumber) {
        const { user } = this.props;
        const query = `Select Id, ID_Number__c, Total_Approved_Receipts_Pri_Sec__c, Active__c, Total_Approved_Receipts_Post_Sec__c FROM Contact where 
            Id_Number__c like '%${idNumber}%' LIMIT 1`;
        const result = await fetchQueryData(query, user.siteToken.hash, user.key);
        if (result.records.length > 0) this.setState({ contactInfo: result.records[0] });
    }

    async getPayoutDate(q) {
        const { user } = this.props;
        const query = `SELECT Scheduled_Payout_Date__c, Status__c FROM Receipt__c WHERE Beneficiary__r.ID_Number__c = '${q}' ORDER BY Scheduled_Payout_Date__c DESC`;
        const result = await fetchQueryData(query, user.siteToken.hash, user.key);

        if (result.records.length === 0) {
            throw new Error(`No beneficiary with ID ${this.props.match.params.query}`);
        }

        const activeReceipts = result.records.filter(row => row.Status__c !== 'Cancelled');

        if (activeReceipts.length === 0) {
            return 'No non-cancelled receipt';
        }

        return moment(activeReceipts[0].Scheduled_Payout_Date__c).format('DD MMMM YYYY');
    }

    async search(q) {
        if (this.state.loading) return;
        if (q === '') return;
        const { user } = this.props;
        this.setState({ loading: true });
        const query = `Select Application__c, Id, ID_Number__c, Name, Applying_To__r.Name, Full_Name__c,
            Application_Status_2__c, No_of_Receipts_Approved__c, Type_of_assistance__c,
            Contact_Name__r.Active__c, Payout_Start__c, Payout_End__c,
            Contact_Name__r.Total_Approved_Receipts_Pri_Sec__c, Contact_Name__r.Total_Approved_Receipts_Post_Sec__c,
            Fail_Standard_Criteria__c, Main_App_Fail_PCI_Housing__c From Person__c
            Where RecordType.Name = 'Beneficiary' 
            and (Id_Number__c like '%${q}%') ORDER BY Application__r.Date_of_Application__c DESC
        `;

        try {
            const result = await fetchQueryData(query, user.siteToken.hash, user.key);
            this.getContact(q);
            this.setState({
                loading: false,
                list: result.records || [],
                latestPayoutDate: await this.getPayoutDate(q),
            });
        } catch (error) {
            swal({
                text: error.toString(),
                title: 'An error occured',
            });
            this.setState({ loading: false });
        }
    }

    render() {
        const columns = [{
            accessor: 'ID_Number__c',
            Header: 'Id Number',
            width: 100,
        }, {
            Header: 'Beneficiary Name',
            accessor: 'Full_Name__c',
            width: 100,
        }, {
            Header: 'Applying To',
            accessor: 'Applying_to__r',
            width: 150,
            Cell: colProps => (colProps.value ? colProps.value.Name : null),
        }, {
            accessor: 'Type_of_assistance__c',
            Header: 'Type of Assistance',
        }, {
            accessor: 'Application_Status_2__c',
            Header: 'Application Status',
        }, {
            accessor: 'No_of_Receipts_Approved__c',
            Header: 'No Of Receipt Approved',
        }, {
            accessor: 'Contact_Name__r',
            Cell: colProps => (colProps.value ? colProps.value.Total_Approved_Receipts_Pri_Sec__c : null),
            Header: 'Total Pri Sec Approved Receipts',
            width: 150,
        }, {
            accessor: 'Contact_Name__r',
            Cell: colProps => (colProps.value ? colProps.value.Total_Approved_Receipts_Post_Sec__c : null),
            Header: 'Total Post Sec Approved Receipts',
            width: 150,
        }, {
            accessor: 'Payout_Start__c',
            Header: 'Start Date',
            Cell: colProps => (colProps.value ? moment(colProps.value).format('DD-MMM-YYYY') : null),
        }, {
            accessor: 'Payout_End__c',
            Header: 'End Date',
            Cell: colProps => (colProps.value ? moment(colProps.value).format('DD-MMM-YYYY') : null),
        }, {
            accessor: 'Contact_Name__r',
            Header: 'Active',
            Cell: colProps => (colProps.value ? <i className={`fa fa-${colProps.value.Active__c ? 'check' : 'times'}`} /> : null),
        }];

        const { contactInfo } = this.state;

        let renewButton = '';
        // Add "Renew" button for partner portal
        const partnerType = ['School', 'Disbursing Agency'];
        if (partnerType.includes(this.props.user.loggedInUser.Account.Partner_Type__c)) {
            // Renew from the latest application of this particular beneficiary
            const applicationId = this.state.list.length ? this.state.list[0].Application__c : '';
            renewButton = (
                <Link
                    className="btn btn-sm btn-default btn-fill"
                    to={`/portal/registration-v2?renewFrom=${applicationId}`}
                    disabled={this.state.list.length === 0}
                >
                    <i className="fa fa-thumbs-up" /> Renew
                </Link>
            );
        }

        return (
            <div className="row">
                <div className="col-md-12">
                    <Print single name="search-result">
                        <div className="card print-area">
                            {this.props.isModal ? null : <h3>Search for {this.props.match.params.query} {this.state.list.length ? `(${this.state.list[0].Full_Name__c})` : ''}</h3>}
                            <NoPrint>
                                <div>
                                    {renewButton}
                                </div>
                            </NoPrint>
                            <p style={{ textAlign: 'center' }}>
                                {this.state.loading ? <i className="fa fa-3x fa-spinner fa-spin" /> : null}
                            </p>
                            {/* <p>
                            Receiving assistance until: <strong>{this.state.latestPayoutDate}</strong>
                        </p> */}
                            <div className="row">
                                <div className="col-md-4">
                                    <p>
                                        Receiving assistance until: <strong>{this.state.latestPayoutDate}</strong>
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <p>
                                        Total months of SPMF Assistance (Pri/Sec) Approved to date: <strong>{contactInfo.Total_Approved_Receipts_Pri_Sec__c || 0} month(s)</strong>
                                    </p>
                                </div>
                                <div className="col-md-4">
                                    <p>
                                        Total months of SPMF Assistance (Post Sec) Approved to date: <strong>{contactInfo.Total_Approved_Receipts_Post_Sec__c || 0} month(s)</strong>
                                    </p>
                                </div>
                            </div>
                            <div className="content table-responsive table-full-width">
                                <ReactTable
                                    data={this.state.list}
                                    columns={columns}
                                    defaultPageSize={this.props.defaultPageSize}
                                />
                            </div>
                        </div>
                    </Print>
                </div>
            </div>
        );
    }
}

BeneficiaryList.propTypes = {
    match: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    isModal: PropTypes.bool,
    defaultPageSize: PropTypes.number,
};

BeneficiaryList.defaultProps = {
    isModal: false,
    defaultPageSize: 10,
};


const mapDispatchToProps = dispatch => (
    bindActionCreators({
    }, dispatch)
);

const mapStateToProps = state => ({
    user: state.user,
    salesforce: state.salesforce,
    personObjectInfo: state.objectInfo.Person__c,
});


export default connect(mapStateToProps, mapDispatchToProps)(BeneficiaryList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Portal/Search.js
// module id = 213
// module chunks = 0